import React, { PureComponent } from 'react'
import './styles.scss'
import Icon from '../../../Icon'
import ComponentLoader from '../component-loader'
import VariantSelect from '../variant-select'
import { getComponentLabel, getFactInstanceName, getTrackingFactLabel } from '../../helper'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { SHAPE_DATA_FACT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import { VARIANT_GROUP_IDS } from '../../constants'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'

class FactInstance extends PureComponent {

  state = {
    isVariantSelectCollapsed: true,
    valid: true,
    validatedAttributes: {}
  }

  onVariantSelectCollapseChange = (collapsed) => {
    this.setState({ isVariantSelectCollapsed: collapsed })
  }

  onSelectedVariantsChange = (selectedVariantIds) => {
    const currentSelectedVariantsLength = (this.props.data.appliesTo?.length || 0)
    const variantIdsAdded = selectedVariantIds.length > currentSelectedVariantsLength
    if (variantIdsAdded) {
      activityTrackingService.trackEvent(trackingEvent.assignToRoom, {
        name: getTrackingFactLabel(this.props.blueprint, this.props.factsheetBlueprint)
      })
    }
    this.props.onSelectedVariantsChange(selectedVariantIds, this.props.index)
  }

  onCollapseToggle = () => {
    if (this.props.collapsed === false) {
      const isValid = this.props.validationStatus?.isValid ?? true
      if (!isValid) {
        return
      }
    }
    this.props.putFactInstanceExpandedStatus(
      this.props.blueprint.id, this.props.index, this.props.collapsed
    )
  }

  getFactInstanceName () {
    const factDefId = this.props.blueprint.id
    const fact = this.props.factsheetBlueprint.factTree.facts[factDefId]
    const componentLabel = getComponentLabel(
      this.props.blueprint, fact)
    return getFactInstanceName(this.props.data,
      this.props.index, componentLabel
    )
  }

  render () {
    const hasComponents = this.props.blueprint.components.length > 0
    const components = this.props.blueprint.components.map((component, index) => {
      return <ComponentLoader
        key={index}
        blueprint={component}
        collapsed={this.props.collapsed}
        factInstanceKey={this.props.index}
        parentBlueprint={this.props.blueprint}
        factsheetBlueprint={this.props.factsheetBlueprint}
        afterDeleteAttribute={this.props.afterDeleteAttribute}
      />
    })
    const factDefId = this.props.blueprint.id
    const fact = this.props.factsheetBlueprint.factTree.facts[factDefId]
    const variantsAllowed = fact.hasOwnProperty('variantGroupTypes')
      && fact.variantGroupTypes.includes(VARIANT_GROUP_IDS.ROOMS)
    const { t } = this.props
    const factDetailToggle = <div className={'fact-checkbox-instance-detail-toggle'}>
              <span className={'Link'} onClick={this.onCollapseToggle}>
              {
                this.props.collapsed ?
                  t('FACT_INSTANCE_EDIT_DETAILS') :
                  t('FACT_INSTANCE_HIDE_DETAILS')
              }
              </span>
    </div>
    if (!hasComponents && !variantsAllowed) {
      return null
    }
    return (
      <div className={'fact-checkbox-instance'}>
        {
          this.props.withHeader && (
            <div className={'fact-checkbox-instance-header'}>
              <div>{this.getFactInstanceName()}</div>
              <span onClick={() => this.props.onFactInstanceDeleteClick(this.props.index)}>
                  <Icon type={'im'} imClassName={'im-minus'} background={'grey'}
                        tooltip={t('FACT_INSTANCE_REMOVE', { label: this.getFactInstanceName() })}/>
                </span>
            </div>
          )
        }
        <div
          className={'fact-checkbox-instance-content' + (this.props.collapsed ? ' fact-checkbox-instance-collapsed' : '')}>
          {
            hasComponents &&
            <div className={'fact-checkbox-instance-content-components-dynamic'}>
              {
                this.props.collapsed ?
                  <div className={'fact-checkbox-instance-separated-comma-wrapper'}>
                    <div className={'fact-checkbox-instance-separated-comma'}>
                      {components}
                    </div>
                    {this.props.allowToggle && factDetailToggle}
                  </div> :
                  <React.Fragment>
                    {components}
                    {this.props.allowToggle && factDetailToggle}
                  </React.Fragment>
              }
            </div>
          }
          {
            variantsAllowed &&
            <div className={'fact-checkbox-instance-content-components-static'}>
              <VariantSelect onSelectedVariantsChange={this.onSelectedVariantsChange}
                             onCollapseChange={this.onVariantSelectCollapseChange}
                             collapsed={this.state.isVariantSelectCollapsed}
                             selectedVariants={this.props.data.appliesTo}/>
            </div>
          }
        </div>
      </div>
    )
  }
}

FactInstance.defaultProps = {
  withHeader: true,
  allowToggle: true,
}
FactInstance.propTypes = {
  blueprint: PropTypes.shape({ components: PropTypes.array.isRequired }).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  index: PropTypes.number.isRequired,
  onFactInstanceDeleteClick: PropTypes.func.isRequired,
  onSelectedVariantsChange: PropTypes.func.isRequired,
  putFactInstanceExpandedStatus: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  data: PropTypes.shape(SHAPE_DATA_FACT).isRequired,
  validationStatus: PropTypes.object,
  withHeader: PropTypes.bool,
  allowToggle: PropTypes.bool,
  afterDeleteAttribute: PropTypes.func,
}
export default withTranslation()(FactInstance)
